import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Page component to process OAuth tokens and redirect to clean URL
 * This handles the OAuth callback and stores tokens in localStorage
 */
export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const redirectPath = searchParams.get('redirect') || '/';

    if (accessToken) {
      // Store tokens in localStorage
      localStorage.setItem('access_token', accessToken);
      if (refreshToken) {
        localStorage.setItem('refresh_token', refreshToken);
      }

      // Build redirect URL with token param
      const redirectUrl = new URL(redirectPath, window.location.origin);
      const params = new URLSearchParams(redirectUrl.search);
      params.set('_token', accessToken);
      if (refreshToken) {
        params.set('_refresh', refreshToken);
      }

      // Preserve all other query params
      searchParams.forEach((value, key) => {
        if (key !== 'access_token' && key !== 'refresh_token' && key !== 'redirect') {
          params.set(key, value);
        }
      });

      redirectUrl.search = params.toString();
      navigate(redirectUrl.pathname + redirectUrl.search, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <div className="text-slate-600">Processing authentication...</div>
      </div>
    </div>
  );
}
